import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { RichTextComponent } from '@domgen/dgx-fe-components/content';
import { PictureComponent } from '@domgen/dgx-fe-components/media';
import { ProgressStepperStep } from '@domgen/dgx-fe-components/progress';
import { SmartFixCustomReminderComponent } from '../../reminder-text/reminder-text.component';

@Component({
  selector: 'progress-stepper-item-smart-fix-hub',
  templateUrl: './progress-stepper-item.component.html',
  styleUrls: ['./progress-stepper-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    PictureComponent,
    RichTextComponent,
    SmartFixCustomReminderComponent,
  ],
  standalone: true,
})
export class SmartFixCustomProgressStepperItemComponent {
  @Input() active = true;
  @Input() step?: ProgressStepperStep;

  constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

  toggleActive(active: boolean) {
    this.active = active;
    this.changeDetectorRef.detectChanges();
  }
}
